import { Avatar, Button, Card, Col, Divider, Drawer, Empty, Form, Input, message, Modal, Popover, Row, Select, Slider, Space, Spin, Switch, Tabs, Tooltip, Typography } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useEffect, useReducer, useRef, useState } from 'react';
import { BarcodeOutlined, DeleteOutlined, InfoOutlined, LeftOutlined, MinusOutlined, PlusOutlined, ReloadOutlined, SettingOutlined } from '@ant-design/icons';

import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';
import { useAuth } from '../Context';
import Plot from 'react-plotly.js';
import { WATERFALL_EVENTS_DATA, WATERFALL_EVENTS_DATA_ERROR, WATERFALL_EVENTS_DATA_SUCCESS, WATERFALL_EVENTS_UPDATE, WATERFALL_EVENTS_UPDATE_ERROR, WATERFALL_EVENTS_UPDATE_SUCCESS, WATERFALL_GRAPH, WATERFALL_GRAPH_CONFIG, WATERFALL_PIPELINE_CONFIG_DATA, WATERFALL_PIPELINE_CONFIG_DATA_ERROR, WATERFALL_PIPELINE_CONFIG_DATA_SUCCESS, WATERFALL_RESET } from './constants';
import waterfallData1 from './reducer';
import eventsicons from '../eventstypes';
import axios from 'axios';
import signBoard from '../../images/sign-board.png';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import TabPane from 'antd/es/tabs/TabPane';
import Fili from 'fili';
import FFT from 'fft.js';

const { Title } = Typography;

// timing settings for the spinner and auto reconnect
const NO_DATA_TIMEOUT = 10000;   // spinner stops after 10s without data
const RECONNECT_DELAY = 20000;   // reconnect 20s after the spinner stops
const MAX_RETRIES = 5;           // stop retrying after 5 attempts

export default function WaterFall () {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));

	const { getAllEvents, eventsData, getPids, pidsData, handleGetMapdata, mapdata, getChannels, channelData  } = useAuth();

	const [spin, setSpin] = useState(false);
	const [depthRangeFrom, setDepthRangeFrom] = useState(null);
	const [depthRangeTo, setDepthRangeTo] = useState(null);
	const [pidsId, setPidsId] = useState();
	const [dassocketurl, setDasSocketUrl] = useState(null);
	const[clickableData, setClickableData] = useState();
	const [isDataModalOpen, setIsDataModalOpen] = useState(false);
	const [channelAndPidsData, setChannelAndPidsData] = useState();
	const [selectdActivity, setSelectedActivity] = useState();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [drawerDepthFrom, setDrawerDepthFrom] = useState();
	const [drawerDepthTo, setDrawerDepthTo] = useState();
	const [dbMin, setDbMin] = useState(-100);
	const [dbMax, setDbMax] = useState(-20);

	const [depthFrom, setDepthFrom] = useState(null);
	const [depthTo, setDepthTo] = useState(null);

	const [zMin, setZMin] = useState(0);
	const [zMax, setZMax] = useState();
	const [zoomDistance, setZoomdistance] = useState(100);
	const [opendrawer, setIsDrawerOpen] = useState(false);
	const [eventconfidencejson, setEventConfidenceJson] = useState({id:[], waterfallEventConfidenceCap:[]});
	const [suppressionUpdateValues, setSuppressionUpdateValues] = useState([{ Start: '', End: '' }]);	
	const navigate = useNavigate();

	const initalState = {graphData:[], loading: false, error: false, piplineGroups : [] };
	const [waterfall, dispatch] = useReducer(waterfallData1, initalState);	

	const [filterchannelId, setfilterchannelId] = useState();

	const [filterType, setFilterType] = useState('none');
	const [characteristic, setcharacteristic] = useState('butterworth');
	const [highcut,setHighCut]= useState(120);
	const [lowcut,setLowCut]= useState(5);
	const [ordervalue,setOrderValue]=useState(4);
	const [sampleFrequency,setsampleFrequency]=useState(2000);
	const [windowSizevalue,setWindowsizeValue]=useState(3);
	const [rmsWindowValue, setRmsWindowValue] = useState(10);
	const [spatialWindowValue, setSpatialWindowValue] = useState(5);
	const [temporalWindowValue, setTemporalWindowValue] = useState(5);
	const [spectrogramWindowValue, setSpectrogramWindowValue] = useState(64);

	// the current websocket and the timers are stored in refs
	const socketRef = useRef(null);
	const spinTimerRef = useRef(null);
	const reconnectTimerRef = useRef(null);
	const retryCountRef = useRef(0);

	const characteristicRef = useRef('butterworth');
	const windowsizeRef = useRef(3);
	const lowcutRef = useRef(5);
	const highcutRef = useRef(120);
	const orderRef = useRef(4);
	const sampleref = useRef(2000);
	const windowsizeRmsRef = useRef(10);
	const integrationCarryRef = useRef(null);
	const spatialWindowRef = useRef(5);
	const temporalWindowRef = useRef(5);
	const temporalHistoryRef = useRef([]);
	const spectrogramWindowRef = useRef(64);
	const spectrogramHistoryRef = useRef([]);

	const filterRef = useRef(null);
	const filterTypeRef = useRef('none');

	const handleFilterChange = (value) => {
		filterTypeRef.current = value;
		setFilterType(value);

		if (value === 'none') {
			filterRef.current = null;
			return;
		}
		filterRef.current = createFilter(value);
		characteristicRef.current = 'butterworth';
		orderRef.current = 4;
		lowcutRef.current = 5;
		highcutRef.current = 120;
		windowsizeRef.current = 3;
		integrationCarryRef.current = null; 
		windowsizeRmsRef.current=10;
		spatialWindowRef.current = 5;
		temporalWindowRef.current =5;
		temporalHistoryRef.current = [];
		setcharacteristic('butterworth');
		setHighCut(120);
		setLowCut(5);
		setOrderValue(4);
		setsampleFrequency(2000);
		setWindowsizeValue(3);
		setRmsWindowValue(10);
		setSpatialWindowValue(5);
		setTemporalWindowValue(5);
		spectrogramWindowRef.current = 64;
		spectrogramHistoryRef.current = [];
		setSpectrogramWindowValue(64);
	};

	const filterOptions = [
		{ label: 'None', value: 'none' },
		{ label: 'Bandpass', value: 'bandpass' },
		{ label: 'Highpass', value: 'highpass' },
		{ label: 'Lowpass', value: 'lowpass' },
		{ label: 'Notch', value: 'notch' },
		{ label: 'Detrend / DC Removal', value: 'detrend' },
		{ label: 'Median', value: 'median' },
		{ label: 'Normalization', value: 'normalization' },
		{ label: 'RMS', value: 'rms' }, 
		{ label: 'PSD', value: 'psd' }, 
		{ label: 'Time Integration', value: 'timeintegration' },
		{ label: 'Spatial Averaging', value: 'spatialaverage' },
		{ label: 'Temporal Averaging', value: 'temporalaverage' },
		{ label: 'Spectrogram', value: 'spectrogram' }
	];

	const characteristicArray = [
		{ label: 'Butterworth', value: 'butterworth' },
	];

	const pidsListFilter = [];

	let tempPidId;
	let tempPidurl;

	let tempstartDepth;
	let tempendDepth;

	let tempChannelId;

	const minPipelineChainage =  waterfall?.piplineGroups?.startendChainage?.minChainage || 0;
	const maxPipelineChainage = waterfall?.piplineGroups?.startendChainage?.maxChainage || 0;
	
	useEffect(() => {		
		setDepthRangeFrom(minPipelineChainage);
		setDepthRangeTo(maxPipelineChainage);
		setDepthFrom(minPipelineChainage);
		setDepthTo(maxPipelineChainage);
		setDrawerDepthFrom(minPipelineChainage);
		setDrawerDepthTo(maxPipelineChainage);
		setZoomdistance(waterfall?.graphConfig?.zoomDistance || 100);
		setZMin(waterfall?.graphConfig?.magThresholds?.minThreshold || 0);
		setZMax(waterfall?.graphConfig?.magThresholds?.maxThreshold || 20);
	},[minPipelineChainage, maxPipelineChainage]);	

	const trueAndFalse = [
		{value: true, label: langdata && langdata.Yes ? langdata.Yes : 'Yes'},
		{value: false, label: langdata && langdata.No ? langdata.No : 'No'}
	];

	const allevents = [];
	eventsData && eventsData.map((item) => {
		allevents.push({
			value : item.id,
			label: item.eventType
		});
	});

	const sortedPidsData = Array.isArray(pidsData)
		? [...pidsData].sort((a, b) => a.id - b.id)
		: [];		

	sortedPidsData && sortedPidsData.map((item,index) => {
		
		if(item){
			pidsListFilter.push({
				value : item.id,
				label : item.name.toUpperCase(),

				dasip: item && item.waterfallip ,
				dasport : item && item.waterfallport,

				dasSocketurl : item && item.waterfallSocketurl,
				dasSocketurlEnabled: item && item.waterfallSocketurlEnabled,
			});
			if (index === 0) {			
				tempPidId = item.id;
				tempPidurl = item && item.waterfallSocketurlEnabled ? `wss://${item && item.waterfallSocketurl}` : `ws://${item && item.waterfallip}:${item && item.waterfallport}`;
			}
		}
	});

	const filterchanneldata = [];

	channelData && channelData?.map((item,index)=>{
		filterchanneldata.push({
			value : item?.channelId,
			label : item?.name
		});

		if (index === 0) {			
			tempChannelId = item?.channelId;
		}
	});

	let pipelineChainage = [];
	
	mapdata &&  mapdata.map((item)=>{
		pipelineChainage.push({
			value:item.pipelineChainage,
			label:item.pipelineChainage.toString()
		});
	});

	useEffect(() => {
		setDepthRangeFrom(tempstartDepth);
		setDepthRangeTo(tempendDepth);
	},[tempstartDepth, tempendDepth]);

	useEffect(() => {
		getPids(authtoken);
	},[]);

	useEffect(()=>{
		if(pidsId != undefined || tempPidId != undefined){
			getChannels(authtoken, pidsId ? pidsId : tempPidId);
		}
	},[pidsId,tempPidId]);

	useEffect(() => {
		getAllEvents(authtoken);

		const pidsinfoIdparams=`pidsinfoId=${pidsId ? pidsId : tempPidId ? tempPidId : null}`;
		const channelinfoIdparams = `&channelId=${filterchannelId ? filterchannelId : tempChannelId ? tempChannelId : null}`;

		dispatch({ type : WATERFALL_PIPELINE_CONFIG_DATA });
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/primarypipelineconfiginfo?${pidsinfoIdparams}${channelinfoIdparams}`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
		};
		
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : WATERFALL_PIPELINE_CONFIG_DATA_SUCCESS, payload : response.data});
				}else {
					dispatch({ type : WATERFALL_PIPELINE_CONFIG_DATA_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : WATERFALL_PIPELINE_CONFIG_DATA_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});

	},[tempPidId, pidsId, tempChannelId , filterchannelId]);

	const createFilter = (filterType) => {
		const calc = new Fili.CalcCascades();
		const Fc = (Number(highcutRef.current) + Number(lowcutRef.current)) / 2;
		const BW = Number(highcutRef.current) - Number(lowcutRef.current);

		switch (filterType) {
		case 'bandpass': {
			const coeffs = calc.bandpass({
				order: orderRef.current,
				characteristic: characteristicRef.current,
				Fs: sampleref.current,
				Fc: Fc,
				BW: BW,
			});

			return new Fili.IirFilter(coeffs);
		}

		case 'highpass': {
			const coeffs = calc.highpass({
				order: orderRef.current,
				characteristic: characteristicRef.current,
				Fs: sampleref.current,
				Fc: lowcutRef.current,
			});

			return new Fili.IirFilter(coeffs);
		}

		case 'lowpass': {
			const coeffs = calc.lowpass({
				order: orderRef.current,
				characteristic: characteristicRef.current,
				Fs: sampleref.current,
				Fc: highcutRef.current,
			});

			return new Fili.IirFilter(coeffs);
		}

		case 'notch': {
			const coeffs = calc.bandstop({
				order: orderRef.current,
				characteristic: characteristicRef.current,
				Fs: sampleref.current,
				Fc: Fc,
				BW: BW,
			});

			return new Fili.IirFilter(coeffs);
		}

		default:
			return null;
		}
	};

	const removeDC = (data) => {
		const mean =
		data.reduce((sum, value) => sum + value, 0) / data.length;

		return data.map((value) => value - mean);
	};

	const medianFilter = (data, windowSize = 3) => {
		const result = new Array(data.length);
		const newwindowsize = windowsizeRef.current ? windowsizeRef.current : windowSize; 
		const half = Math.floor(newwindowsize / 2);

		for (let i = 0; i < data.length; i++) {

			const start = Math.max(0, i - half);
			const end = Math.min(data.length, i + half + 1);

			const window = data
				.slice(start, end)
				.sort((a, b) => a - b);

			const middle = Math.floor(window.length / 2);

			result[i] = window[middle];
		}

		return result;
	};

	const normalize = (data) => {
		const min = Math.min(...data);
		const max = Math.max(...data);

		if (max === min) {
			return data.map(() => 0);
		}

		return data.map((value) => {
			return (value - min) / (max - min);
		});
	};

	const applyDCRemoval = (rows) => {
		return rows.map((row) => {
			return removeDC(Array.from(row));
		});
	};

	const applyMedianFilter = (rows) => {
		return rows.map((row) => {
			return medianFilter(Array.from(row), 3);
		});
	};

	const toDb = (power) => 10 * Math.log10(power + 1e-12);
	const isSpectrogramMode = filterType === 'spectrogram';
	const isPsdMode = filterType === 'psd';
	const isDbMode = isPsdMode || isSpectrogramMode;

	const dbZRange = React.useMemo(() => {
		if (!isDbMode) return null;
		const data = waterfall && waterfall.graphData && waterfall.graphData.data;
		if (!data || data.length === 0) return null;

		let min = Infinity;
		let max = -Infinity;
		for (const row of data) {
			for (const v of row) {
				if (v < min) min = v;
				if (v > max) max = v;
			}
		}
		if (min === Infinity) return null;
		if (min === max) { min -= 1; max += 1; }

		return { min, max };
	}, [waterfall && waterfall.graphData && waterfall.graphData.data, isDbMode]);

	useEffect(() => {
		if (isDbMode && dbZRange) {
			setDbMin(dbZRange.min);
			setDbMax(dbZRange.max);
		}
	}, [isDbMode, dbZRange]);

	const applyNormalization = (rows) => {
		return rows.map((row) => {
			return normalize(Array.from(row));
		});
	};

	const rmsFilter = (data, windowSize = 10) => {
		const result = new Array(data.length);
		const size = windowsizeRmsRef.current ? windowsizeRmsRef.current : windowSize;
		const half = Math.floor(size / 2);

		for (let i = 0; i < data.length; i++) {
			const start = Math.max(0, i - half);
			const end = Math.min(data.length, i + half + 1);
			const window = data.slice(start, end);
			const meanSquare = window.reduce((sum, v) => sum + v * v, 0) / window.length;
			result[i] = Math.sqrt(meanSquare);
		}
		return result;
	};

	const applyRMSFilter = (rows) => {
		return rows.map((row) => rmsFilter(Array.from(row)));
	};

	const nextPowerOfTwo = (n) => {
		let p = 1;
		while (p < n) p *= 2;
		return p;
	};
	
	const psdNfft = nextPowerOfTwo(waterfall?.graphData?.depths?.length || 0);
	const spectrogramNfft = nextPowerOfTwo(spectrogramWindowValue || 64);

	const freqBins = (n, sampleRate) => {
		const half = n / 2;
		const df = (sampleRate || 1) / n;
		return Array.from({ length: half }, (_, i) => i * df);
	};

	const computePSD = (data, sampleRate) => {
		const n = nextPowerOfTwo(data.length);

		const padded = new Float64Array(n);
		padded.set(data);

		const fft = new FFT(n);
		const complexInput = fft.toComplexArray(padded);
		const out = fft.createComplexArray();
		fft.transform(out, complexInput);

		const half = n / 2;
		const psd = new Array(half);
		for (let i = 0; i < half; i++) {
			const re = out[2 * i];
			const im = out[2 * i + 1];
			const power = i === 0 ? 0 : (re * re + im * im) / (n * sampleRate);
			psd[i] = toDb(power); 
		}
		return psd;
	};

	const applyPSDFilter = (rows) => {
		return rows.map((row) => computePSD(Array.from(row), sampleref.current));
	};

	const applyTimeIntegration = (rows) => {
		const dt = 1 / (sampleref.current || 1);

		return rows.map((row) => {
			const data = Array.from(row);
			const result = new Array(data.length);

			let running = integrationCarryRef.current ? integrationCarryRef.current[integrationCarryRef.current.length - 1] : 0;

			for (let i = 0; i < data.length; i++) {
				running += data[i] * dt;
				result[i] = running;
			}

			integrationCarryRef.current = result;
			return result;
		});
	};

	const spatialAverageFilter = (data, windowSize = 5) => {
		const result = new Array(data.length);
		const size = spatialWindowRef.current ? spatialWindowRef.current : windowSize;
		const half = Math.floor(size / 2);

		for (let i = 0; i < data.length; i++) {
			const start = Math.max(0, i - half);
			const end = Math.min(data.length, i + half + 1);
			const window = data.slice(start, end);
			const mean = window.reduce((sum, v) => sum + v, 0) / window.length;
			result[i] = mean;
		}
		return result;
	};

	const applySpatialAverage = (rows) => {
		return rows.map((row) => spatialAverageFilter(Array.from(row)));
	};

	const applyTemporalAverage = (rows) => {
		const windowSize = temporalWindowRef.current ? Number(temporalWindowRef.current) : 5;

		temporalHistoryRef.current.push(rows.map((row) => Array.from(row)));

		if (temporalHistoryRef.current.length > windowSize) {
			temporalHistoryRef.current.shift();
		}

		const history = temporalHistoryRef.current;
		const rowCount = rows.length;
		const colCount = rows[0] ? rows[0].length : 0;

		const result = new Array(rowCount);
		for (let r = 0; r < rowCount; r++) {
			const avgRow = new Array(colCount).fill(0);
			let framesUsed = 0;

			for (let f = 0; f < history.length; f++) {
				if (!history[f][r]) continue;
				framesUsed++;
				for (let c = 0; c < colCount; c++) {
					avgRow[c] += history[f][r][c];
				}
			}

			for (let c = 0; c < colCount; c++) {
				avgRow[c] = framesUsed ? avgRow[c] / framesUsed : 0;
			}

			result[r] = avgRow;
		}

		return result;
	};

	const computeSpectrogram = (rows) => {
		const nfft = nextPowerOfTwo(spectrogramWindowRef.current || 64);
		const numChannels = rows[0] ? rows[0].length : 0;

		rows.forEach((row) => {
			spectrogramHistoryRef.current.push(Array.from(row));
		});

		if (spectrogramHistoryRef.current.length > nfft) {
			spectrogramHistoryRef.current = spectrogramHistoryRef.current.slice(-nfft);
		}

		const history = spectrogramHistoryRef.current;
		const half = nfft / 2;

		if (history.length < nfft || numChannels === 0) {
			return Array.from({ length: half }, () => new Array(numChannels).fill(0));
		}

		const fft = new FFT(nfft);
		const result = Array.from({ length: half }, () => new Array(numChannels).fill(0));

		for (let c = 0; c < numChannels; c++) {
			const timeSeries = new Float64Array(nfft);
			for (let t = 0; t < nfft; t++) {
				timeSeries[t] = history[t][c];
			}

			const complexInput = fft.toComplexArray(timeSeries);
			const out = fft.createComplexArray();
			fft.transform(out, complexInput);

			for (let f = 0; f < half; f++) {
				const re = out[2 * f];
				const im = out[2 * f + 1];
				const power = f === 0 ? 0 : (re * re + im * im) / (nfft * (sampleref.current || 1));
				result[f][c] = toDb(power); 
			}
		}

		return result;
	};

	const applySpectrogramFilter = (rows) => computeSpectrogram(rows);

	const applyFilter = (rows, filter) => {
		switch (filterTypeRef.current) {
		case 'bandpass':
		case 'highpass':
		case 'lowpass':
		case 'notch':
			return rows.map((row) => {
				return filter.multiStep(Array.from(row));
			});

		case 'detrend':
			return applyDCRemoval(rows);

		case 'median':
			return applyMedianFilter(rows);

		case 'normalization':
			return applyNormalization(rows);
		case 'rms':
			return applyRMSFilter(rows);
		case 'psd':
			return applyPSDFilter(rows);
		case 'timeintegration':
			return applyTimeIntegration(rows);
		case 'spatialaverage':
			return applySpatialAverage(rows);
		case 'temporalaverage':
			return applyTemporalAverage(rows);
		case 'spectrogram':
			return applySpectrogramFilter(rows);

		case 'none':
		default:
			return rows;
		}
	};

	const handleCharacteristicChange = (value)=>{
		characteristicRef.current = value;
		setcharacteristic(value);
	};

	// helper to stop the "no data" safety timer
	const clearSpinTimer = () => {
		if (spinTimerRef.current) {
			clearTimeout(spinTimerRef.current);
			spinTimerRef.current = null;
		}
	};

	// helper to stop a pending reconnect
	const clearReconnectTimer = () => {
		if (reconnectTimerRef.current) {
			clearTimeout(reconnectTimerRef.current);
			reconnectTimerRef.current = null;
		}
	};

	// plans ONE reconnect. Safe to call many times, it only plans once.
	const scheduleReconnect = (url, channelId, socket) => {
		if (socketRef.current !== socket) return;        // old socket, do not reconnect
		if (reconnectTimerRef.current) return;           // a reconnect is already planned

		if (retryCountRef.current >= MAX_RETRIES) {
			message.config({ duration : 5, maxCount : 1 });
			message.open({
				type: 'error',
				content: 'Unable to connect to the server. Please check the connection and refresh the page.',
			});
			return;
		}

		retryCountRef.current += 1;

		reconnectTimerRef.current = setTimeout(() => {
			reconnectTimerRef.current = null;
			webSocketDataDAS(url, channelId);
		}, RECONNECT_DELAY);
	};

	// opens ONE socket for the given url + channel
	const webSocketDataDAS = (url, channelId) => {

		// close any previous socket first
		if (socketRef.current) {
			const oldSocket = socketRef.current;
			socketRef.current = null;   // set null first, so oldSocket cannot change state
			oldSocket.close();
		}
		clearSpinTimer();
		clearReconnectTimer();

		try {
			const socket = new WebSocket(url);
			socketRef.current = socket;
			socket.binaryType = 'arraybuffer';

			setSpin(true);

			// if no data arrives in 10 seconds: stop the spinner and plan a reconnect
			spinTimerRef.current = setTimeout(() => {
				// mark the timer as finished, so onclose knows we are no longer waiting
				spinTimerRef.current = null;
				if (socketRef.current === socket) {
					setSpin(false);
					scheduleReconnect(url, channelId, socket);
				}
			}, NO_DATA_TIMEOUT);

			let metaCache = null;

			socket.onopen = () => {
				console.log('WebSocket connection opened');
				if (socketRef.current !== socket) return;   // old socket, do nothing else
				socket.send(JSON.stringify({
					channelId: channelId
				}));
			};

			socket.onmessage = (event) => {
				if (socketRef.current !== socket) return;   // old socket, ignore

				try {
					// metadata JSON
					if (typeof event.data === 'string') {
						metaCache = JSON.parse(event.data);
						return;
					}

					if (!metaCache) return;
					if (!(event.data instanceof ArrayBuffer)) return;

					const { shape, times, depths } = metaCache;
					const [rows, cols] = shape;

					const bytes = new Uint8Array(event.data);

					const newRows = new Array(rows);
					for (let r = 0; r < rows; r++) {
						const row = new Float32Array(cols);

						for (let c = 0; c < cols; c++) {
							row[c] = bytes[r * cols + c] / 255;
						}

						newRows[r] = row;
					}

					const filteredRows = filterTypeRef.current !== 'none' ? applyFilter(newRows, filterRef.current) : newRows;

					dispatch({
						type: WATERFALL_GRAPH,
						payload: {
							data: filteredRows,
							times,
							depths
						}
					});

					// data is flowing, so everything is healthy again
					retryCountRef.current = 0;
					clearReconnectTimer();
					clearSpinTimer();
					setSpin(false);

				} catch (error) {
					clearSpinTimer();
					setSpin(false);
					console.error('Error parsing data:', error);
				}
			};

			// while the 10s timer is running, do not turn the spinner off here
			socket.onerror = (error) => {
				if (socketRef.current !== socket) return;   // old socket, ignore
				console.error('WebSocket error:', error);

				// If the 10s timer is still running, let it handle the spinner and the retry.
				// Only turn the spinner off here if no timer is running.
				if (!spinTimerRef.current) {
					setSpin(false);
				}
			};

			// while still waiting for first data, keep the spinner on
			socket.onclose = () => {
				// always print the log, even for old sockets
				console.log('WebSocket connection closed');

				// only the CURRENT socket may touch the spinner and the graph
				if (socketRef.current !== socket) return;

				dispatch({ type : WATERFALL_GRAPH, payload : [] });

				if (spinTimerRef.current) {
					// Still waiting for first data: keep the spinner ON.
					// The 10s timer will turn it off and plan the reconnect.
					return;
				}

				// Connection dropped after data was already flowing (or the timer already finished)
				setSpin(false);
				scheduleReconnect(url, channelId, socket);
			};

		} catch (error) {
			clearSpinTimer();
			setSpin(false);
			console.error('WebSocket error:', error);
			dispatch({ type : WATERFALL_GRAPH, payload : [] });
			message.config({
				duration : 5,
				maxCount : 1,
			});
			message.open({
				type: 'error',
				content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
			});
			navigate('/connection-error');
		}
	};	

	// only open the socket when BOTH the url and the channel are ready.
	// cleanup closes the socket and cancels any planned reconnect.
	useEffect(() => {
		const url = dassocketurl || tempPidurl;
		const channel = filterchannelId || tempChannelId;

		if (!url || !channel) return;   // wait until both are known

		retryCountRef.current = 0;      // new url or channel means a fresh start
		webSocketDataDAS(url, channel);

		return () => {
			clearSpinTimer();
			clearReconnectTimer();      // never reconnect after we left on purpose
			if (socketRef.current) {
				const s = socketRef.current;
				socketRef.current = null;   // so it cannot change state or reconnect
				s.close();                  // its onclose will still print the log
			}
		};
	}, [tempPidurl, dassocketurl, tempChannelId, filterchannelId]);
	
	const handleSetPids = (e , options) =>{		
		dispatch({ type: WATERFALL_RESET });
		tempPidId=e;
		setPidsId(e);
		setfilterchannelId(null);

		if(options.dasSocketurlEnabled){
			setDasSocketUrl(`wss://${options.dasSocketurl}`);
		}else{
			setDasSocketUrl(`ws://${options.dasip}:${options.dasport}`);
		}
	};

	const handleSetchannel = (e) =>{
		dispatch({ type: WATERFALL_RESET });
		tempChannelId=e;
		setfilterchannelId(e);
	};
				
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);	

	const bandPassPlotData = [{
		z: waterfall && waterfall.graphData && waterfall.graphData.data,
		y: isSpectrogramMode
			? freqBins(spectrogramNfft, sampleref.current)
			: (waterfall && waterfall.graphData && waterfall.graphData.times),
		x: isPsdMode
			? freqBins(psdNfft, sampleref.current)
			: (waterfall && waterfall.graphData && waterfall.graphData.depths),
		colorscale: 'Viridis',
		type: 'heatmap',
		zmin: isDbMode ? dbMin : zMin,
		zmax: isDbMode ? dbMax : zMax,
		hovertemplate: isSpectrogramMode
			? ' Distance (m): %{x} <br> Frequency (Hz): %{y} <br> Power: %{z} <extra></extra>'
			: isPsdMode
				? ' Frequency (Hz) : %{x} <br> Time : %{y} <br> Power : %{z} <extra></extra>'
				: ' Distance (m) : %{x} <br> Time : %{y} <br> Amplitude : %{z} <extra></extra>',

		colorbar: {x: 1,   thickness: 10,
			outlinewidth: 0},
		orientation: '',

	}];	

	const bandPassLayout = {
		title : false,
		fontWeight: 800,
		autosize: true,
		yaxis: {
			title: isSpectrogramMode ? 'Frequency (Hz)' : (langdata && langdata.Time ? langdata.Time : 'Time'),
			type: isSpectrogramMode ? 'linear' : 'date',
		},
		xaxis: { 
			title: isPsdMode ? 'Frequency (Hz)' : (langdata?.Distancem ?? 'Distance (m)'),
			range: isPsdMode
				? [0, (sampleref.current || 1) / 2]
				: (depthRangeFrom || depthRangeFrom == 0 && depthRangeTo || depthRangeTo == 0
					? [depthRangeFrom, depthRangeTo]
					: [tempstartDepth, tempendDepth]),
			tick0: null,
			dtick:  null,
			minor: {
				ticks: 'outside',
				ticklen: 5,
				showgrid: false,
			}
		},
		height: 0,
		dragmode: 'select',
		plot_bgcolor: 'rgba(0,0,0,0)',
		margin: {t: 10, b: 40 },
	};

	const event_markers = [];
	let eventData = 'Machine Digging';
	eventsicons && eventsicons.map((icondata)=>{
		if(icondata.type === eventData) {				
			event_markers.push([ icondata.severity[3]]);
		}
	});

	const markerLayout = {
		title: false,
		fontWeight: 800,
		autosize: true,
		yaxis: { 
			title: langdata && langdata.Magnitude ? langdata.Magnitude : 'Magnitude',
			range: zMin || zMin == 0 &&  zMax || zMax == 0 ? [zMin,zMax] : [0, 5],
			fixedrange: true,
			dtick: false,
			showticklabels: true,
			ticks: 'outside',
			showline: true,
			zeroline: false,
			showgrid: false,
		},
		xaxis: { 
			title: langdata && langdata.Distancem ? langdata.Distancem : 'Distance (m)',
			range: depthRangeFrom || depthRangeFrom == 0 && depthRangeTo  || depthRangeTo == 0
				? [depthRangeFrom, depthRangeTo]
				: [tempstartDepth, tempendDepth],
			tick0: null,
			dtick: null,
			showticklabels: true,
			ticks: 'outside',
			showline: true,
			zeroline: false,
			showgrid: false,
			minor: {
				ticks: 'outside',
				ticklen: 5,
				showgrid: false,
			}
		},
		height: 0,
		dragmode: 'select',
		margin: { t: 20},
		images: [],
	};
	
	waterfall?.piplineGroups?.primaryChainagesarray && waterfall?.piplineGroups?.primaryChainagesarray.map((item) => {
		markerLayout.images.push(
			{
				source: signBoard,
				x: item,
				y: zMin > 0 ? (zMin/1.5)+(zMax/5) : zMin + (zMax/5),
				xref: 'x',
				yref: 'y',
				sizex: (depthRangeFrom - depthRangeTo) / 50,
				sizey: 30,
				xanchor: 'center',
				yanchor: 'middle',
				layer: 'above',
			}
		);
	});
	
	const hoverTextArray = [];
	for (const i in waterfall && waterfall.graphData && waterfall.graphData.anomaly_type) {
		eventsicons && eventsicons.map((icondata)=>{
			
			if(icondata.type === waterfall.graphData.anomaly_type[i]) {				
				markerLayout.images.push(
					{
						source: icondata.severity[3],
						x: waterfall.graphData.anomaly_depths[i],
						y: zMin > 0 ? (zMin/1.5)+(zMax/6) : zMin + (zMax/6),
						xref: 'x',
						yref: 'y',
						sizex: (depthRangeFrom - depthRangeTo) / 70,
						sizey: 30,
						xanchor: 'center',
						yanchor: 'middle',
						layer: 'above',
					}				
				);

				hoverTextArray.push(
					`Event: ${waterfall.graphData.anomaly_type[i]}<br>Chainage: ${waterfall.graphData.anomaly_depths[i]}`
				);
			}
		});
	}	
	
	const terrainCircleTrace = [{
		x: waterfall?.piplineGroups?.groupedterrainChainagearray ? waterfall?.piplineGroups?.groupedterrainChainagearray : [],
		y: Array.isArray(waterfall?.piplineGroups?.groupedterrainChainagearray) ? Array(waterfall?.piplineGroups?.groupedterrainChainagearray.length).fill(zMin) : [],
		mode: 'markers',
		marker: {
			color: 'rgba(135, 206, 250, 0.5)',
			size: 20,
			line: {
				color: 'MediumPurple',
				width: 2
			},
		},
		name: 'Terrain',
		hoverinfo: 'text',
		hovertext: waterfall?.piplineGroups?.groupIdChainageinfoArray,
		showlegend: false,
	}];		

	terrainCircleTrace.push({
		x: waterfall && waterfall.graphData && waterfall.graphData.anomaly_depths ? waterfall.graphData.anomaly_depths : [],
		y: Array.isArray(waterfall && waterfall.graphData && waterfall.graphData.anomaly_depths) ? Array(waterfall && waterfall.graphData && waterfall.graphData.anomaly_depths.length).fill(zMin + 1) : [],
		mode: 'markers',
		marker: {
			color: 'rgba(0,0,0,0)',
			size: 40
		},
		hovertext: hoverTextArray,
		hoverinfo: 'text',
		showlegend: false
	});

	terrainCircleTrace.push({
		x: waterfall?.piplineGroups?.primaryChainagesarray ? waterfall?.piplineGroups?.primaryChainagesarray : [],
		y: Array.isArray(waterfall?.piplineGroups?.primaryChainagesarray) ? Array(waterfall?.piplineGroups?.primaryChainagesarray.length).fill(zMin) : [],
		mode: 'markers',
		marker: {
			color: 'rgba(0,0,0,0)',
			size: 40
		},
		hovertext: waterfall?.piplineGroups?.primayChainageinfoArray ? waterfall?.piplineGroups?.primayChainageinfoArray : [],
		hoverinfo: 'text',
		showlegend: false
	});

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	const handleRangefrom = (e) => {				
		if(e.target.value) {
			setDepthRangeFrom(parseInt(e.target.value));
		} else {
			setDepthRangeFrom();
		}
	};

	const handleRangeTo = (e) => {
		if(e.target.value && e.target.value >= depthFrom && e.target.value <= depthTo){
			if(e.target.value && e.target.value >= depthRangeFrom) {
				setDepthRangeTo(parseInt(e.target.value));	
			} else {
				message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
				setDepthRangeTo();
			}
		}else{
			message.warning(langdata && langdata.Maxvaluescannotbegreaterthantheentirelength ? langdata.Maxvaluescannotbegreaterthantheentirelength : 'Max values cannot be greater than the entire length.');
			setDepthRangeTo(depthTo);
		}
	};		

	const handleScalefrom = (e) => {				
		if(e.target.value) {
			setZMin(e.target.value);
		} else {
			setZMin();
		}
	};

	const handleScaleTo = (e) => {
		if(e.target.value) {
			// if(e.target.value > 100) {
			// 	message.warning(langdata && langdata.MaxValuecannotbegreaterthan100 ? langdata.MaxValuecannotbegreaterthan100 : 'Max value cannot be greater than 100.');
			// 	return false;
			// }
			setZMax(e.target.value);
			// if(e.target.value > zMin) {
			// }
			// else {
			// 	message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
			// }
		} else {
			setZMax();
		}
	};	
	
	const handleWaterfallSelect = (value) => {
		if(value?.range){
			const from = Math.round(value.range.x[0]);
			const to = Math.round(value.range.x[1]);
			setDepthRangeFrom(from);
			setDepthRangeTo(to);
		}
	};
	
	const hansleResetDepth = () => {
		setDepthRangeFrom(minPipelineChainage);
		setDepthRangeTo(maxPipelineChainage);
		setDrawerDepthFrom(minPipelineChainage);
		setDrawerDepthTo(maxPipelineChainage);
		setDepthFrom(minPipelineChainage);
		setDepthTo(maxPipelineChainage);
	};	
	
	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{ langdata && langdata.waterfallcontent ? langdata.waterfallcontent :  'This module displays live visualization data from various PIDS. It includes predicted events detected across the system, along with a graphical representation of PIDS-allocated pipelines. Each Icon shows detailed information about detected events and chainage info.'}</p>
		</Card>
	);

	const handleZoomIn = () => {
		if((depthRangeFrom + zoomDistance) < (depthRangeTo - zoomDistance)){
			setDepthRangeFrom(depthRangeFrom + zoomDistance);
			setDepthRangeTo(depthRangeTo - zoomDistance);
		}
	};

	const handleZoomOut = () => {
		if((depthRangeFrom > minPipelineChainage) && (depthRangeTo <= maxPipelineChainage)){
			setDepthRangeFrom(depthRangeFrom - zoomDistance);
			setDepthRangeTo(depthRangeTo + zoomDistance);
		}
	};

	const handleClick = (value) => {
		setClickableData( value.points[0]);
		setIsDataModalOpen(true);
		setChannelAndPidsData({
			channel_id : waterfall && waterfall.graphData && waterfall.graphData.channel_id,
			channel_name : waterfall && waterfall.graphData && waterfall.graphData.channel_name,
			pids_id : waterfall && waterfall.graphData && waterfall.graphData.pids_id,
			pids_name : waterfall && waterfall.graphData && waterfall.graphData.pids_name,
		});		
	};

	const waterfallGraphConfig = () => {

		let params = '';		
		if(pidsId || tempPidId) {
			params += `pidsinfoId=${pidsId ? pidsId : tempPidId}`;
			
			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${api}/waterfallconfig?${params}`,
				headers: { 
					Authorization:`Bearer ${authtoken}`	
				}
			};
			
			axios.request(config)
				.then((response) => {
					if(response.status == 200) {
						dispatch({ type : WATERFALL_GRAPH_CONFIG, payload : response.data });
					}
				})
				.catch((error) => {
					console.log(error);
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
		}
	};

	useEffect(() => {
		waterfallGraphConfig();
	},[pidsId, tempPidId]);

	const formik = useFormik({
		enableReinitialize: true,
		initialValues : {
			id : waterfall.graphConfig && waterfall.graphConfig.id,
			pidsinfoId : waterfall.graphConfig && waterfall.graphConfig.pidsinfoId,
			minMagThreshold : waterfall.graphConfig && waterfall.graphConfig.magThresholds && waterfall.graphConfig.magThresholds.minThreshold,
			maxMagThreshold : waterfall.graphConfig && waterfall.graphConfig.magThresholds && waterfall.graphConfig.magThresholds.maxThreshold,
			minAmpSNThresholds : waterfall.graphConfig && waterfall.graphConfig.ampSNThresholds && waterfall.graphConfig.ampSNThresholds.minThreshold,
			maxAmpSNThresholds : waterfall.graphConfig && waterfall.graphConfig.ampSNThresholds && waterfall.graphConfig.ampSNThresholds.maxThreshold,
			minAmpFreqThresholds : waterfall.graphConfig && waterfall.graphConfig.ampFreqThresholds && waterfall.graphConfig.ampFreqThresholds.minThreshold,
			maxAmpFreqThresholds : waterfall.graphConfig && waterfall.graphConfig.ampFreqThresholds && waterfall.graphConfig.ampFreqThresholds.maxThreshold,
			magThresholdsOverride : waterfall.graphConfig && waterfall.graphConfig.magThresholdsOverride,
			ampSNThresholdsOverride : waterfall.graphConfig && waterfall.graphConfig.ampSNThresholdsOverride,
			ampFreqThresholdsOverride : waterfall.graphConfig && waterfall.graphConfig.ampFreqThresholdsOverride,
			defaultminMagThreshold : waterfall.graphConfig && waterfall.graphConfig.magThresholds && waterfall.graphConfig.magThresholds.defaultminThreshold,
			defaultmaxMagThreshold : waterfall.graphConfig && waterfall.graphConfig.magThresholds && waterfall.graphConfig.magThresholds.defaultmaxThreshold,
			defaultminAmpSNThresholds : waterfall.graphConfig && waterfall.graphConfig.ampSNThresholds && waterfall.graphConfig.ampSNThresholds.defaultminThreshold,
			defaultmaxAmpSNThresholds : waterfall.graphConfig && waterfall.graphConfig.ampSNThresholds && waterfall.graphConfig.ampSNThresholds.defaultmaxThreshold,
			defaultminAmpFreqThresholds : waterfall.graphConfig && waterfall.graphConfig.ampFreqThresholds && waterfall.graphConfig.ampFreqThresholds.defaultminThreshold,
			defaultmaxAmpFreqThresholds : waterfall.graphConfig && waterfall.graphConfig.ampFreqThresholds && waterfall.graphConfig.ampFreqThresholds.defaultmaxThreshold,
			zoomDistance: waterfall.graphConfig && waterfall.graphConfig.zoomDistance ? waterfall.graphConfig.zoomDistance : 100,
			FPS : waterfall.graphConfig && waterfall.graphConfig.FPS ? waterfall.graphConfig.FPS : 10,
			sampleRate : waterfall.graphConfig && waterfall.graphConfig.sampleRate ? waterfall.graphConfig.sampleRate : 100,
			isLogging: waterfall.graphConfig && waterfall.graphConfig.isLogging ? waterfall.graphConfig.isLogging : false,
			deviceName: waterfall.graphConfig && waterfall.graphConfig.deviceName ? waterfall.graphConfig.deviceName : '',
			directory: waterfall.graphConfig && waterfall.graphConfig.directory ? waterfall.graphConfig.directory : '',
			fileName: waterfall.graphConfig && waterfall.graphConfig.fileName ? waterfall.graphConfig.fileName : '',
			suppressions: waterfall.graphConfig && waterfall.graphConfig.suppressions ? waterfall.graphConfig.suppressions : null,
		},
		onSubmit: () => {			
				
			const id = parseInt(formik.values.id);
			const start = [];
			const end = [];
			const filtertypevalue = filterTypeRef.current;
			if(!suppressionUpdateValues || suppressionUpdateValues.length > 0 && suppressionUpdateValues.some((input) => input.Start === '' || input.End === '')) {
				Modal.warning({title : langdata && langdata.Pleasefillallsuppressionfields ? langdata.Pleasefillallsuppressionfields : 'Please fill all suppression fields'});
				return false;
			}
			if(formik.values.minMagThreshold > formik.values.maxMagThreshold) {
				message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
				return false;
			}

			suppressionUpdateValues && suppressionUpdateValues.map((input) => {
				start.push(input.Start);
				end.push(input.End);
			});
			
			let data = JSON.stringify({
				'magThresholds': {
					'maxThreshold': formik.values.maxMagThreshold,
					'minThreshold': formik.values.minMagThreshold,
					'defaultmaxThreshold': formik.values.defaultmaxMagThreshold,
					'defaultminThreshold': formik.values.defaultminMagThreshold
				},
				'magThresholdsOverride': formik.values.magThresholdsOverride ,
				'ampFreqThresholds': {
					'maxThreshold': formik.values.maxAmpFreqThresholds,
					'minThreshold': formik.values.minAmpFreqThresholds,
					'defaultmaxThreshold': formik.values.defaultmaxAmpFreqThresholds,
					'defaultminThreshold': formik.values.defaultminAmpFreqThresholds
				},
				'ampFreqThresholdsOverride': formik.values.ampFreqThresholdsOverride ,
				'ampSNThresholds': {
					'maxThreshold': formik.values.maxAmpSNThresholds,
					'minThreshold': formik.values.minAmpSNThresholds,
					'defaultmaxThreshold': formik.values.defaultmaxAmpSNThresholds,
					'defaultminThreshold': formik.values.defaultminAmpSNThresholds
				},
				'ampSNThresholdsOverride': formik.values.ampSNThresholdsOverride ,
				'zoomDistance': parseInt(formik.values.zoomDistance),
				'FPS': parseInt(formik.values.FPS),
				'sampleRate': parseInt(formik.values.sampleRate),
				'isLogging': formik.values.isLogging,
				'directory': formik.values.directory,
				'deviceName': formik.values.deviceName,
				'fileName': formik.values.fileName,
				'suppressions': {
					'end': end,
					'start': start
				},
			});
	
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/waterfallconfig/${id}`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`	
				},
				data : data
			};
			filterRef.current = null;

			try {
				filterRef.current = createFilter(filtertypevalue);
				if (!filterRef.current) {
					console.error('createFilter returned null/undefined for type:', filtertypevalue, {
						characteristic: characteristicRef.current,
						order: orderRef.current,
						lowcut: lowcutRef.current,
						highcut: highcutRef.current,
					});
				}
			} catch (err) {
				console.error('Filter creation failed:', {
					filtertypevalue,
					characteristic: characteristicRef.current,
					order: orderRef.current,
					lowcut: lowcutRef.current,
					highcut: highcutRef.current,
					error: err,
				});
				Modal.warning({
					title: 'Unable to create filter',
					content: err.message || 'Invalid filter parameters. Please check the filter settings.',
				});
				return false;
			}

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201) {
						waterfallGraphConfig();
						Modal.success({ title: langdata && langdata.Graphdetailssuccessfullyupdated ? langdata.Graphdetailssuccessfullyupdated : 'Graph details successfully updated.' });
						setIsModalOpen(false);
						setDepthRangeFrom(drawerDepthFrom);
						setDepthRangeTo(drawerDepthTo);
					} else {
						Modal.warning({ title: langdata && langdata.Unabletoupdategraphdetails ? langdata.Unabletoupdategraphdetails : 'Unable to update graph details' });
					}
				})
				.catch((error) => {
					console.log(error);
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Unabletoupdategraphdetails ? langdata.Unabletoupdategraphdetails : 'Unable to update graph details' });
					}
				});
		}
	});

	const depthMarks = {
		[depthFrom ? depthFrom : tempstartDepth] : langdata && langdata.Min ? langdata.Min : 'Min',
		[depthTo ? depthTo : tempendDepth] :langdata && langdata.Max ? langdata.Max : 'Max', 
	};	

	const ampMarks = {
		0: langdata && langdata.Min ? langdata.Min : 'Min',
		20000 : langdata && langdata.Max ? langdata.Max : 'Max',
	};		

	const dasFrequencyMarks = {
		0: langdata && langdata.Min ? langdata.Min : 'Min',
		20000 : langdata && langdata.Max ? langdata.Max : 'Max',
	};

	const handleOk = () => {
		setIsDataModalOpen(false);
		setIsModalOpen(false);
		formik.resetForm();
	};
	const handleCancel = () => {
		setIsDataModalOpen(false);
		setIsModalOpen(false);
		formik.resetForm();
	};

	const handleSelectEvent = (value) => {
		setSelectedActivity(value);
	};

	const handleNavigateSimulation = () => {
		navigate(( '/add-simulations'),{ state: {time : clickableData && clickableData.y, depth : Math.trunc(clickableData && clickableData.x ), 
			activity : selectdActivity, channelAndPidsData : channelAndPidsData} });
	};

	const showModal = () => {
		setIsModalOpen(true);
	};

	const showDrawer = () => {
		handleGetMapdata(authtoken);
		setIsDrawerOpen(true);
		getWaterfallevents();
		const startArr =  formik?.values?.suppressions?.start || [];
		const endArr = formik?.values?.suppressions?.end || [];
		const result = startArr.map((startValue, idx) => ({
			Start: startValue,
			End: endArr[idx]
		}));
		setSuppressionUpdateValues(result);
	};

	const getWaterfallevents = () => {

		dispatch({ type : WATERFALL_EVENTS_DATA});
		let params = '';		
		params += 'isWaterfallEvent=true';
			
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/allevents?${params}`,
			headers: { 
				Authorization:`Bearer ${authtoken}`	
			}
		};
			
		axios.request(config)
			.then((response) => {
				if(response.status == 200) {
					dispatch({ type : WATERFALL_EVENTS_DATA_SUCCESS, payload : response.data });
				}
				else{
					dispatch({ type : WATERFALL_EVENTS_DATA_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : WATERFALL_EVENTS_DATA_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	};

	const handleReset = () => {
		formik.resetForm();
		setDepthRangeFrom(minPipelineChainage);
		setDepthRangeTo(maxPipelineChainage);
		setDrawerDepthFrom(minPipelineChainage);
		setDrawerDepthTo(maxPipelineChainage);
		setDepthFrom(minPipelineChainage);
		setDepthTo(maxPipelineChainage);
	};
	
	const handleDepthChange = (value) => {
		if(parseInt(value[0]) <= depthTo){
			setDrawerDepthFrom(parseInt(value[0]));
			setDrawerDepthTo(drawerDepthTo ? drawerDepthTo : depthRangeTo);
		}else{
			message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
			setDrawerDepthFrom();
		}
		if(parseInt(value[1]) >= depthFrom && parseInt(value[1]) <= depthTo){
			if(value[1] && value[1] >= drawerDepthFrom) {
				setDrawerDepthTo(parseInt(value[1]));	
			} else {
				message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
				setDrawerDepthTo();
			}
		}else{
			message.warning(langdata && langdata.Maxvaluescannotbegreaterthantheentirelength ? langdata.Maxvaluescannotbegreaterthantheentirelength : 'Max values cannot be greater than the entire length.');
			setDrawerDepthTo();
		}
	};

	const handleInputDepthRangefrom = (e) => {
		if(e.target.value && e.target.value <= depthTo){
			setDrawerDepthFrom(parseInt(e.target.value));
			setDrawerDepthTo(drawerDepthTo ? drawerDepthTo : depthRangeTo);
		}else{
			message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
			setDrawerDepthFrom();
		}
	};

	const handleInputDepthRangeTo = (e) => {
		if(e.target.value && e.target.value >= depthFrom && e.target.value <= depthTo){
			if(e.target.value && e.target.value >= drawerDepthFrom) {
				setDrawerDepthTo(parseInt(e.target.value));	
				setDrawerDepthFrom(drawerDepthFrom ? drawerDepthFrom : depthRangeFrom);
			} else {
				message.warning(langdata && langdata.MaxValuescannotbelessthanminvalue ? langdata.MaxValuescannotbelessthanminvalue : 'Max values cannot be less than min value.');
				setDrawerDepthTo();
			}
		}else{
			message.warning(langdata && langdata.Maxvaluescannotbegreaterthantheentirelength ? langdata.Maxvaluescannotbegreaterthantheentirelength : 'Max values cannot be greater than the entire length.');
			setDrawerDepthTo(depthTo);
		}
	};

	const onClose = () => {
		setIsDrawerOpen(false);
		setEventConfidenceJson({id:[], waterfallEventConfidenceCap:[]});
	};

	const handleConfidenceChange =(item, e) => {
		
		let ids = Array.isArray(eventconfidencejson.id) ? [...eventconfidencejson.id] : [];
		let caps = Array.isArray(eventconfidencejson.waterfallEventConfidenceCap) ? [...eventconfidencejson.waterfallEventConfidenceCap] : [];

		const idx = ids.indexOf(item.id);
		if (idx !== -1) {
			caps[idx] = e.target.value;
		} else {
			ids.push(item.id);
			caps.push(e.target.value);
		}

		setEventConfidenceJson({
			...eventconfidencejson,	
			id: ids,
			waterfallEventConfidenceCap: caps
		});
	};

	const handleApplyConfidence = () => {

		dispatch({ type : WATERFALL_EVENTS_UPDATE });
		let data = {
			'id' :eventconfidencejson.id,
			'waterfallEventConfidenceCap' : eventconfidencejson.waterfallEventConfidenceCap
		};		
		
		let config = {
			method: 'patch',
			maxBodyLength: Infinity,
			url: `${api}/bulkupdate-allevents`,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : data
		};
		
		axios.request(config)
			.then((response) => {
				if ( response.status === 200 || response.status === 201 || response.status === 204 ) {
					dispatch({ type : WATERFALL_EVENTS_UPDATE_SUCCESS});
					getWaterfallevents();
					Modal.success({ title: langdata && langdata.Eventconfidenceupdatedsuccessfully ? langdata.Eventconfidenceupdatedsuccessfully : 'Event confidence updated successfully.' });
				}else {
					dispatch ({ type :WATERFALL_EVENTS_UPDATE_ERROR });
					Modal.error({ title: langdata && langdata.Failedtoupdateeventconfidence ? langdata.Failedtoupdateeventconfidence : 'Failed to update event confidence.' });
				}
			})
			.catch((error) => {
				dispatch ({ type : WATERFALL_EVENTS_UPDATE_ERROR });
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
		
	};

	const handleUpdateChangeSuppression = (index, field, value) => {
		const newSuppressionValues = [...suppressionUpdateValues];
		newSuppressionValues[index][field] = value;
		setSuppressionUpdateValues(newSuppressionValues);
	};

	const handleUpdateAddSuppression = () => {
		setSuppressionUpdateValues([...suppressionUpdateValues, { Start: '', End: '' }]);
	};

	const handleUpdateDeleteSuppression = (index) => {
		setSuppressionUpdateValues(suppressionUpdateValues.filter((_, i) => i !== index));
	};

	useEffect(() => {
		const startArr =  formik?.values?.suppressions?.start || [];
		const endArr = formik?.values?.suppressions?.end || [];
		const result = startArr.map((startValue, idx) => ({
			Start: startValue,
			End: endArr[idx]
		}));
		setSuppressionUpdateValues(result);
	},[formik?.values?.suppressions]);
		

	return (
		<>
			<Content>
				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={5}>
						<Row>
							<Space>
								<BarcodeOutlined style={{fontSize:'30px'}}/>
							</Space>
							<Space>&nbsp;&nbsp;</Space>
							<Title level={4} style={{ paddingTop:'10px'}}> {langdata && langdata.Waterfall ? langdata.Waterfall : 'Waterfall'}</Title>
							<Space>&nbsp;&nbsp;</Space>
						</Row>
					</Col>
					<Col span={19}>
						<Row justify="end">
							<Col>
								<Tooltip placement="bottom" title={langdata && langdata.Filterbypids ? langdata.Filterbypids:'Filter by pids'}>
									<Space>
										<Select Item
											showSearch
											filterOption={filterOption}
											style={{ minWidth: '200px', maxWidth:'200px', margin:'5px'}}
											placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS:'Select PIDS'}
											optionFilterProp="children"
											options={pidsListFilter}
											value={pidsId ? pidsId : tempPidId}
											onSelect={(e, options)=>handleSetPids(e, options)}
										/>
									</Space>
								</Tooltip>

								<Tooltip placement="bottom" title={langdata && langdata.Filterbychannel ? langdata.Filterbychannel:'Filter by channel'}>
									<Space>
										<Select Item
											showSearch
											filterOption={filterOption}
											style={{ minWidth: '200px', maxWidth:'200px', margin:'5px'}}
											placeholder={langdata && langdata.SelectChannel ? langdata.SelectChannel:'Select Channel'}
											optionFilterProp="children"
											options={filterchanneldata}
											value={filterchannelId ? filterchannelId : tempChannelId}
											onSelect={(e)=>handleSetchannel(e)}
										/>
									</Space>
								</Tooltip>
								
								<Space>&nbsp;</Space>
								<Space>
									<Tooltip placement="bottom" title={langdata && langdata.GraphConfigurations ? langdata.GraphConfigurations: 'Graph Configurations'}>
										<Button style ={{margin:'5px'}} type='primary' onClick={showModal} icon={<SettingOutlined size="small" />}/>
									</Tooltip>
								</Space>
								<Space>&nbsp;</Space>
								<Popover title={langdata.Waterfall ? langdata.Waterfall : 'Waterfall' }  content={infoContent} trigger="click">
									<Avatar size="small"><InfoOutlined /></Avatar>
								</Popover>
								<Space>&nbsp;</Space>
								<Space>
									<Tooltip placement="bottom" title={langdata && langdata.DataTransformation ? langdata.DataTransformation:'Data Transformation'}>
										<Button style ={{margin:'5px'}} type='primary' onClick={showDrawer} icon={<LeftOutlined size="small" />}/>
									</Tooltip>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>		


				{dassocketurl || tempPidurl ? 
					<>
						<Col span={24} style={{padding:'10px'}}>
							<Row style={{ backgroundColor : 'white', marginBottom : '10px'}}>
								<Col span={12} style={{marginTop:'0px', fontSize : '10px'}}
									className="waterfall" >
									<b style={{fontSize : '12px'}}>{langdata && langdata.CurrentlyViewing ? langdata.CurrentlyViewing : 'Currently Viewing'}</b>
									<p style={{ marginTop : '5px'}}>  {langdata && langdata.ChannelName ? langdata.ChannelName : 'Channel Name'} : {waterfall && waterfall.graphData && waterfall.graphData.channel_name} </p>
								</Col>
								<Col  span={12} style={{marginTop:'5px',fontSize : '10px', display : 'flex', justifyContent : 'flex-end'}}>
									<Tooltip placement="bottom" title="Select Filter Type" > 
										<Select
											style={{ width: '200px', margin: '15px' }}
											showSearch
											filterOption={(input, option) =>
												option.label.toLowerCase().includes(input.toLowerCase())
											}
											placeholder="Select Filter Type"
											optionFilterProp="label"
											options={filterOptions}
											value={filterType}
											onSelect={(value, option) => {
												handleFilterChange(value, option);
											}}
										/>
									</Tooltip>
									<Tooltip placement="bottom" title={langdata && langdata.EnterScaleRange ? langdata.EnterScaleRange:'Enter Scale Range'}>
										<Space.Compact size="small" style={{ width : '150px', margin:'15px'}}>
											{isDbMode ? (
												<>
													<Input
														type="number"
														value={dbMin}
														step="0.1"
														onChange={(e) => setDbMin(Number(e.target.value))}
														placeholder="Min dB"
													/>

													<Input
														type="number"
														value={dbMax}
														step="0.1"
														onChange={(e) => setDbMax(Number(e.target.value))}
														placeholder="Max dB"
													/>
												</>
											) : (
												<>
													<Input
														type="number"
														value={zMin}
														step="0.1"
														onChange={handleScalefrom}
														placeholder="Min"
													/>

													<Input
														type="number"
														value={zMax}
														step="0.1"
														onChange={handleScaleTo}
														placeholder="Max"
													/>
												</>
											)}
										</Space.Compact>
									</Tooltip>
									
									<Tooltip placement="bottom" title={langdata && langdata.EnterDistanceRange ? langdata.EnterDistanceRange:'Enter Distance Range'}>
										<Space.Compact size="small" style={{ width : '240px', margin:'15px'}}>
											<Input type='number'  value={depthRangeFrom} placeholder={langdata && langdata.DepthRangeFrom ? langdata.DepthRangeFrom: 'Depth Range From'} onChange={handleRangefrom} />
											<Input
												type="number"
												value={depthRangeTo}
												placeholder={langdata && langdata.DepthRangeTo ? langdata.DepthRangeTo : 'Depth Range To'}
												onChange={(e) => setDepthRangeTo(e.target.value)}
												onBlur={handleRangeTo}
											/>
										</Space.Compact>
									</Tooltip>
									
								</Col>
							</Row>
							<Row justify='end'>

								<Col span={24} className='zoomInfo' style={{ display : 'flex', justifyContent : 'flex-end', marginRight : '20px', width : 'auto'}}>
									<Tooltip placement="bottom" title={langdata && langdata.ResetDistanceRange ? langdata.ResetDistanceRange:'Reset Distance Range'}>
										<Button type="primary" icon={<ReloadOutlined />} onClick={hansleResetDepth} size='small' />
									</Tooltip>
								</Col>

								<Col span={24} className='zoomInfo' style={{ display : 'flex', justifyContent : 'flex-end', marginRight : '20px', marginTop : '40px', width : 'auto'}}>
									<Tooltip placement="bottom" title={langdata && langdata.ZoomIn ? langdata.ZoomIn:'Zoom In'}>
										<Button 
											type="primary" 
											icon={<PlusOutlined />} 
											onClick={handleZoomIn}
											size='small' />
									</Tooltip>
								</Col>
								<Col span={24} className='zoomInfo' style={{ display : 'flex', justifyContent : 'flex-end', marginRight : '20px', marginTop : '80px', width : 'auto'}}>
									<Tooltip placement="bottom" title={langdata && langdata.ZoomOut ? langdata.ZoomOut:'Zoom Out'}>
										<Button 
											type="primary" 
											icon={<MinusOutlined />} 
											onClick={handleZoomOut}
											size='small' />
									</Tooltip>
								</Col>
							</Row>
							<Col>
								<Plot
									data={terrainCircleTrace}
									layout={ markerLayout}
									style={{ width: '100%', height: '200px', marginTop : '-25px' }}
									onSelected={(event) => {
										handleWaterfallSelect(event);
									}}
									config={{ 
										responsive: true,
										displaylogo : false,
										modeBarButtonsToRemove: [
											'pan2d',
											'zoom2d',
											'zoomIn2d',
											'zoomOut2d',
											'autoScale2d',
											'resetScale2d',
											'hoverClosestCartesian',
											'hoverCompareCartesian',
											'zoom3d',
											'pan3d',
											'resetViews3d',
											'hoverClosest3d',
											'hoverCompare3d',
											'orbitRotation',
											'tableRotation',
											'resetCameraDefault3d',
											'resetCameraLastSave3d',
										],
									}}
								/>
							</Col>
							<Col>
								<Plot
									data={bandPassPlotData}
									layout={ bandPassLayout}
									style={{ width: '100%', height: '650px', marginTop : '-25px' }}
									onSelected={(event) => {
										handleWaterfallSelect(event);
									}}
									onClick={(value) => {handleClick(value);}}
									config={{ 
										responsive: true,
										displayModeBar: true,
										displaylogo : false,
										modeBarButtonsToRemove: [
											'pan2d',
											'zoom2d',
											'zoomIn2d',
											'zoomOut2d',
											'autoScale2d',
											'resetScale2d',
											'hoverClosestCartesian',
											'hoverCompareCartesian',
											'zoom3d',
											'pan3d',
											'resetViews3d',
											'hoverClosest3d',
											'hoverCompare3d',
											'orbitRotation',
											'tableRotation',
											'resetCameraDefault3d',
											'resetCameraLastSave3d',
										],
									}}
								/>
							</Col>
						</Col>
					</>
							
					: 
					<Row span={24} style={{
						margin: '10px',
						paddingLeft: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={24}>							
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						</Col>
					</Row>
				}

				<Modal
					title={langdata && langdata.SaveforTraining ? langdata.SaveforTraining : 'Save for Training'}
					open={isDataModalOpen} 
					onOk={handleOk} 
					onCancel={handleCancel}
					maskClosable={false}
					footer={[
						<Space key ='options'>
							<Button style={{ margin : '5px'}} onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
							<Button  type="primary" onClick={handleNavigateSimulation} style={{ margin : '5px'}} >{langdata && langdata.NEXT ? langdata.NEXT : 'NEXT'}</Button>
						</Space>
					]}
				>
					<Row gutter={24}>
						<Col span={24}>
							<b>{langdata && langdata.Time ? langdata.Time :  'Time'} : </b>{clickableData && clickableData.x}
						</Col>
						<Col span={24} style={{ marginTop : '5px'}}>
							<b>{langdata && langdata.Distancem ? langdata.Distancem :  'Distance (m)'} : </b>{clickableData && clickableData.y}
						</Col>
						<Col span={24} style={{ marginTop : '5px'}}>
							<b>{langdata && langdata.Magnitude ? langdata.Magnitude :  'Magnitude'} : </b>{clickableData && clickableData.z}
						</Col>
						<Col span={24} style={{ marginTop : '10px'}}>
							<Form.Item label={langdata && langdata.Label ? langdata.Label :  'Label'} >
								<Select Item
									style={{ width: '360px'}}
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.SelectEvent ? langdata.SelectEvent :'Select Event'}
									optionFilterProp="children"
									options={allevents}
									onSelect={(value, options) => {handleSelectEvent(options);}}
								/>
							</Form.Item>
						</Col>
					</Row>
				</Modal>


				<Modal
					title={langdata && langdata.GraphConfigurations ? langdata.GraphConfigurations: 'Graph Configurations' }
					open={isModalOpen} 
					onOk={handleOk} 
					onCancel={handleCancel}
					maskClosable={false}
					footer={[
						<>
							<Row style={{
								margin: '10px',
								paddingLeft: '10px',
								paddingRight: '10px',
								background: '#FFFFFF',
								alignItems: 'center',
								marginTop : '10px'
							}}
							>
								<Col span={8}>
								</Col>
								<Col span={16}>
									<Row justify="end">
										<Col>
											<Space>
												<Button style={{ margin : '5px'}} onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
											</Space>
											<Space>&nbsp;</Space>
											<Space>
												<Button onClick={formik.handleSubmit} type="primary" style={{ margin : '5px'}} >{langdata && langdata.UPDATE ? langdata.UPDATE : 'UPDATE'}</Button>
											</Space>
										</Col>
									</Row>
								</Col>
							</Row>
						</>
					]}
					width={1000}
				>		
					<Divider/>
					<Row gutter={24}>
						<Col span={23}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.DAS ? langdata.DAS:'DAS'}</b></Typography>
						</Col>
						<Col  justify="end"  span={1}>
							<Tooltip placement="bottom" title={langdata && langdata.Reset ? langdata.Reset : 'Reset'}>
								<Avatar size="small" style={{ backgroundColor : '#1677FF'}}>							
									<ReloadOutlined onClick={handleReset} />	
								</Avatar>
							</Tooltip>
						</Col>
					</Row>
					<>

						<Row gutter={24} >
							<Col span={8}>
								<Typography style={{ marginTop : '15px'}}>{langdata && langdata.Magnitude ? langdata.Magnitude: 'Magnitude'}&nbsp;&nbsp;&nbsp;
									<Tooltip placement="bottom" title={langdata && langdata.Enterthemagnituderanges ? langdata.Enterthemagnituderanges:'Enter the magnitude ranges'}>
										<Input 
											type='number'
											step={.1} 
											max={50}
											style={{width : '20%', height  :'25px'}}
											disabled = {formik.values.magThresholdsOverride == true ? false : true}
											value={formik.values.magThresholdsOverride == true ? formik.values.minMagThreshold :  formik.values.defaultminMagThreshold}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 20) ? (formik.setFieldValue('minMagThreshold', e.target.value), setZMin(e.target.value)) : null;
											}}
										/>
										{' '} <span > -  </span>{' '}
										<Input  
											type='number'
											step={.1} 
											max={50}
											min={0}
											style={{width : '20%', height  :'25px'}}
											disabled = {formik.values.magThresholdsOverride == true ? false : true}
											value={formik.values.magThresholdsOverride == true ? formik.values.maxMagThreshold : formik.values.defaultmaxMagThreshold}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 20) ? (formik.setFieldValue('maxMagThreshold', e.target.value), setZMax(e.target.value)) : null;
											}}
										/>
									</Tooltip>
								</Typography>
								<Slider 
									style={{marginTop:'20px'}}
									range 
									step={.1}
									max={50} 
									onChange={(value) => {formik.setFieldValue('minMagThreshold', value[0]);formik.setFieldValue('maxMagThreshold', value[1]);}} 
									marks={ampMarks} 
									disabled = {formik.values.magThresholdsOverride == true ? false : true}
									value={[formik.values.magThresholdsOverride == true ? formik.values.minMagThreshold :  formik.values.defaultminMagThreshold, formik.values.magThresholdsOverride == true ? formik.values.maxMagThreshold : formik.values.defaultmaxMagThreshold]}/>
							</Col>
							<Col span={8}>
								<Typography style={{ marginTop : '15px'}}>{langdata && langdata.CutoffFrequencyHz ? langdata.CutoffFrequencyHz: 'Cutoff Frequency (Hz)'}&nbsp;&nbsp;&nbsp;
									<Tooltip placement="bottom" title={langdata && langdata.Entercutofffrequencyrange ? langdata.Entercutofffrequencyrange:'Enter cutoff frequency range'}>
										<Input 
											type='number'
											style={{width : '20%', height  :'25px'}}
											disabled = {formik.values.ampFreqThresholdsOverride == true ? false : true}
											value={formik.values.ampFreqThresholdsOverride == true ? formik.values.minAmpFreqThresholds : formik.values.defaultminAmpFreqThresholds}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 20000) ? formik.setFieldValue('minAmpFreqThresholds', e.target.value) : null;
											}}
										/>
										{' '} <span > -  </span>{' '}
										<Input  
											type='number'
											style={{width : '20%', height  :'25px'}}
											disabled = {formik.values.ampFreqThresholdsOverride == true ? false : true}
											value={formik.values.ampFreqThresholdsOverride == true ? formik.values.maxAmpFreqThresholds : formik.values.defaultmaxAmpFreqThresholds}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 20000) ? formik.setFieldValue('maxAmpFreqThresholds', e.target.value) : null;
											}}
										/>
									</Tooltip>
								</Typography>
								<Slider 
									style={{marginTop:'20px'}}
									range step={10} 
									max={20000} 
									onChange={(value) => {formik.setFieldValue('minAmpFreqThresholds', value[0]);formik.setFieldValue('maxAmpFreqThresholds', value[1]);}} 
									marks={dasFrequencyMarks}
									disabled = {formik.values.ampFreqThresholdsOverride == true ? false : true}
									value={[formik.values.ampFreqThresholdsOverride == true ? formik.values.minAmpFreqThresholds : formik.values.defaultminAmpFreqThresholds, formik.values.ampFreqThresholdsOverride == true ? formik.values.maxAmpFreqThresholds : formik.values.defaultmaxAmpFreqThresholds]}/>
							</Col>

							<Col span={8}>
								<Typography style={{ marginTop : '15px'}}>{langdata && langdata.SNRatio ? langdata.SNRatio: 'S/N Ratio'}&nbsp;&nbsp;&nbsp;
									<Tooltip placement="bottom" title={langdata && langdata.EnterSNratiorange ? langdata.EnterSNratiorange:'Enter S/N ratio range'}>
										<Input 
											type='number'
											style={{width : '20%', height  :'25px'}}
											disabled = {formik.values.ampSNThresholdsOverride == true ? false : true}
											value={formik.values.ampSNThresholdsOverride == true ? formik.values.minAmpSNThresholds : formik.values.defaultminAmpSNThresholds}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 20000) ? formik.setFieldValue('minAmpSNThresholds', e.target.value) : null;
											}}
										/>
										{' '} <span > -  </span>{' '}
										<Input  
											type='number'
											style={{width : '20%', height  :'25px'}}
											disabled = {formik.values.ampSNThresholdsOverride == true ? false : true}
											value={formik.values.ampSNThresholdsOverride == true ? formik.values.maxAmpSNThresholds : formik.values.defaultmaxAmpSNThresholds}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 20000) ? formik.setFieldValue('maxAmpSNThresholds', e.target.value) : null;
											}}
										/>
									</Tooltip>
								</Typography>
								<Slider 
									style={{marginTop:'20px'}}
									range step={10} 
									max={20000} 
									onChange={(value) => {formik.setFieldValue('minAmpSNThresholds', value[0]);formik.setFieldValue('maxAmpSNThresholds', value[1]);}} 
									marks={dasFrequencyMarks}
									disabled = {formik.values.ampSNThresholdsOverride == true ? false : true}
									value={[formik.values.ampSNThresholdsOverride == true ? formik.values.minAmpSNThresholds : formik.values.defaultminAmpSNThresholds, formik.values.ampSNThresholdsOverride == true ? formik.values.maxAmpSNThresholds : formik.values.defaultmaxAmpSNThresholds]}/>
							</Col>


							<Col span={8}>
								<Row>
									<Space>
										<Tooltip  placement="bottom" title={langdata && langdata.Override ? langdata.Override : 'Override'}>
											<Switch 
												size="small" 
												onClick={(value) => {formik.setFieldValue('magThresholdsOverride', value);}}
												checked={formik.values.magThresholdsOverride}/>
										</Tooltip>
									</Space>
								</Row>
							</Col>
							<Col span={8}>
								<Row>
									<Space>
										<Tooltip placement="bottom" title={langdata && langdata.Override ? langdata.Override : 'Override'}>
											<Switch 
												size="small" 
												onClick={(value) => {formik.setFieldValue('ampFreqThresholdsOverride', value);}}
												checked={formik.values.ampFreqThresholdsOverride}/>
										</Tooltip>
									</Space>
								</Row>
							</Col>

							<Col span={8}>
								<Row>
									<Space>
										<Tooltip placement="bottom" title={langdata && langdata.Override ? langdata.Override : 'Override'}>
											<Switch 
												size="small" 
												onClick={(value) => {formik.setFieldValue('ampSNThresholdsOverride', value);}}
												checked={formik.values.ampSNThresholdsOverride}/>
										</Tooltip>
									</Space>
								</Row>
							</Col>
						</Row>
						<Divider/>

						<Row gutter={24} >
							<Col span={8}>
								<Typography style={{ marginTop : '15px'}}>{langdata && langdata.FramesPerSecond ? langdata.FramesPerSecond: 'Frames Per Second'}&nbsp;&nbsp;&nbsp;
									<Tooltip placement="bottom" title={langdata && langdata.PleaseentertheFramesPerSecond ? langdata.PleaseentertheFramesPerSecond:'Please enter the Frames Per Second'}>
										<Input 
											type='number'
											style={{width : '40%', height  :'25px'}}
											value={formik.values.FPS}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 240) ? formik.setFieldValue('FPS', e.target.value) : null;
											}}
										/>
									</Tooltip>
								</Typography>
								<Slider 
									style={{marginTop:'20px'}}
									range 
									step={10} 
									max={240} 
									onChange={(value) => {formik.setFieldValue('FPS', value[1]);}} 
									marks={ampMarks} 
									value={[0,formik.values.FPS]}/>
							</Col>
							<Col span={8}>
								<Typography style={{ marginTop : '15px'}}>{langdata && langdata.ZoomDistancem ? langdata.ZoomDistancem: 'Zoom Distance (m)'}&nbsp;&nbsp;&nbsp;
									<Tooltip placement="bottom" title={langdata && langdata.Pleaseenterthezoomdistance ? langdata.Pleaseenterthezoomdistance:'Please enter the zoom distance'}>
										<Input 
											type='number'
											style={{width : '40%', height  :'25px'}}
											value={formik.values.zoomDistance}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 1000) ? (formik.setFieldValue('zoomDistance', e.target.value), setZoomdistance(e.target.value)) : null;
											}}
										/>
										
									</Tooltip>
								</Typography>
								<Slider 
									style={{marginTop:'20px'}}
									range step={10} 
									max={1000} 
									onChange={(value) => {formik.setFieldValue('zoomDistance', value[1]);setZoomdistance(value[1]);}} 
									marks={dasFrequencyMarks}
									value={[0, formik.values.zoomDistance]}/>
							</Col>

							<Col span={8}>
								<Typography style={{ marginTop : '15px'}}>{langdata && langdata.SampleRate ? langdata.SampleRate: 'Sample Rate (sps)'}&nbsp;&nbsp;&nbsp;
									<Tooltip placement="bottom" title={langdata && langdata.Pleaseenterthesamplerate ? langdata.Pleaseenterthesamplerate:'Please enter the sample rate'}>
										<Input 
											type='number'
											style={{width : '40%', height  :'25px'}}
											value={formik.values.sampleRate}
											onChange={(e) => {(e.target.value >= 0 && e.target.value <= 10000) ? formik.setFieldValue('sampleRate', e.target.value) : null;
											}}
										/>
										
									</Tooltip>
								</Typography>
								<Slider 
									style={{marginTop:'20px'}}
									range step={10} 
									max={10000} 
									onChange={(value) => {formik.setFieldValue('sampleRate', value[1]);}} 
									marks={dasFrequencyMarks}
									value={[0, formik.values.sampleRate]}/>
							</Col>

						</Row>
						<Divider/>

					</>
					
					<Row gutter={24} >
						<Col span={24}>
							<Typography style={{ marginTop : '15px'}}>{langdata && langdata.Distancem ? langdata.Distancem  : 'Distance (m)'}&nbsp;&nbsp;&nbsp;
								<Tooltip placement="bottom" title={langdata && langdata.EnterDistanceRange ? langdata.EnterDistanceRange:'Enter Distance Range'}>
									<Input 
										type='number' 
										style={{width : '15%', height  :'25px'}}
										value={drawerDepthFrom}
										max={maxPipelineChainage} 
										min={minPipelineChainage} 
										placeholder={langdata && langdata.DepthRangeFrom ? langdata.DepthRangeFrom: 'Depth Range From'} 
										onChange={handleInputDepthRangefrom} 
									/>
									{' '} <span > -  </span>{' '}
									<Input 
										type='number' 
										style={{width : '15%', height  :'25px'}}
										value={drawerDepthTo}
										defaultValue={depthTo}
										max={maxPipelineChainage} 
										min={minPipelineChainage} 
										placeholder={langdata && langdata.DepthRangeTo ? langdata.DepthRangeTo: 'Depth Range To'} 
										onChange={(e) => setDrawerDepthTo(e.target.value)}
										onBlur={handleInputDepthRangeTo}
									/>
								</Tooltip>
							</Typography>
							<Slider style={{marginTop:'20px'}} range max={maxPipelineChainage} onChange={handleDepthChange} marks={depthMarks} value={[drawerDepthFrom, drawerDepthTo ? drawerDepthTo : depthRangeTo]} />
						</Col>
					</Row>
					<Divider/>
					
					<Row gutter={24}>
						<Col span={23}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.Filters ? langdata.Filters:'Filters'}</b></Typography>
						</Col>
					</Row> 
					{(filterTypeRef.current!='none') ?<>

						<Row gutter={24}>
							{ (filterTypeRef.current === 'bandpass' || filterTypeRef.current === 'highpass' || filterTypeRef.current === 'notch'|| filterTypeRef.current === 'lowpass')  ?<>
								<Col span={6}>
									<Typography.Text>
										{langdata && langdata.SampleSize ? langdata.SampleSize : 'Sample Size'}
									</Typography.Text>
									<div style={{ marginTop: '8px' }}>
										<Tooltip
											placement="bottom"
											title={
												langdata && langdata.SelectSampleSize
													? langdata.SelectSampleSize
													: 'Select Sample Size'
											}
										>
											<Input
												type="number"
												step={1}
												min={0}
												style={{ width: '100%' }}
												value={sampleFrequency}
												onChange={(e) => {
													sampleref.current = e.target.value;
													setsampleFrequency(e.target.value);
												}}
											/>
										</Tooltip>
									</div>
								</Col>
								<Col span={6}>
									<Typography.Text>
										{langdata && langdata.Order ? langdata.Order : 'Order'}
									</Typography.Text>
									<div style={{ marginTop: '8px' }}>
										<Tooltip
											placement="bottom"
											title={
												langdata && langdata.SelectOrder
													? langdata.SelectOrder
													: 'Select Order'
											}
										>
											<Input
												type="number"
												step={0}
												min={0}
												style={{ width: '100%' }}
												value={ordervalue}
												onChange={(e) => {
													orderRef.current = e.target.value;
													setOrderValue(e.target.value);
												}}
											/>
										</Tooltip>
									</div>
								</Col>

								<Col span={6}>
									<Typography.Text>
										{langdata && langdata.characteristic ? langdata.characteristic : 'Characteristic'}
									</Typography.Text>
									<div style={{ marginTop: '8px' }}>
										<Tooltip
											placement="bottom"
											title={langdata && langdata.selectcharacterstic ? langdata.selectcharacterstic : 'Select Characterstic'}
										>
											<Select
												style={{ width: '100%' }}
												showSearch
												filterOption={(input, option) =>
													option.label.toLowerCase().includes(input.toLowerCase())
												}
												placeholder={langdata && langdata.selectcharacterstic ? langdata.selectcharacterstic : 'Select Characterstic'}
												optionFilterProp="label"
												options={characteristicArray}
												value={characteristic}
												onSelect={(value, option) => {
													handleCharacteristicChange(value, option);
												}}
											/>
										</Tooltip>
									</div>
								</Col>

								{(filterTypeRef.current === 'bandpass' || filterTypeRef.current === 'highpass' || filterTypeRef.current === 'notch') ? 
									<Col span={6}>
										<Typography.Text>
											{langdata && langdata.Lowcut ? langdata.Lowcut : 'Lowcut'}
										</Typography.Text>
										<div style={{ marginTop: '8px' }}>
											<Tooltip
												placement="bottom"
												title={langdata && langdata.SelectLowCut ? langdata.SelectLowCut : 'Select LowCut'}
											>
												<Input
													type="number"
													style={{ width: '100%' }}
													value={lowcut}
													onChange={(e) => {lowcutRef.current = e.target.value;
														setLowCut(e.target.value);
													}}
												/>
											</Tooltip>
										</div>
									</Col> 
									: null}

								{(filterTypeRef.current === 'bandpass' || filterTypeRef.current === 'lowpass' || filterTypeRef.current === 'notch') ? <Col span={6}>
									<Typography.Text  style={{ display: 'block', marginTop: '8px' }}>
										{langdata && langdata.Highcut ? langdata.Highcut : 'Highcut'}
									</Typography.Text>
									<div style={{ marginTop: '8px' }}>
										<Tooltip
											placement="bottom"
											title={langdata && langdata.SelectHighCut ? langdata.SelectHighCut : 'Select HighCut'}
										>
											<Input
												type="number"
												style={{ width: '100%' }}
												value={highcut}
												onChange={(e) => {highcutRef.current = e.target.value;
													setHighCut(e.target.value);
												}}
											/>
										</Tooltip>
									</div>
								</Col>
									: null}
							</> :
								filterTypeRef.current === 'median' ? 
									<>

										<Col span={6}>
											<Typography.Text>
												{langdata && langdata.windowsize ? langdata.windowsize : 'Window size'}
											</Typography.Text>
											<div style={{ marginTop: '8px' }}>
												<Tooltip
													placement="bottom"
													title={langdata && langdata.selectwindowsize ? langdata.selectwindowsize : 'Select Window Size '}
												>
													<Input
														type="number"
														style={{ width: '100%' }}
														value={windowSizevalue}
														onChange={(e) => {windowsizeRef.current = e.target.value;
															setWindowsizeValue(e.target.value);
														}}
													/>
												</Tooltip>
											</div>
										</Col> 
										
									</> 
									:  filterTypeRef.current === 'rms' ? (
										<Col span={6}>
											<Typography.Text>
												{langdata && langdata.windowsize ? langdata.windowsize : 'Window size'}
											</Typography.Text>
											<div style={{ marginTop: '8px' }}>
												<Tooltip
													placement="bottom"
													title={langdata && langdata.selectwindowsize ? langdata.selectwindowsize : 'Select Window Size'}
												>
													<Input
														type="number"
														style={{ width: '100%' }}
														value={rmsWindowValue}
														onChange={(e) => {
															windowsizeRmsRef.current = e.target.value;
															setRmsWindowValue(e.target.value);
														}}
													/>
												</Tooltip>
											</div>
										</Col>
									):filterTypeRef.current === 'spatialaverage' ? (
										<Col span={6}>
											<Typography.Text>Spatial Window Size</Typography.Text>
											<div style={{ marginTop: '8px' }}>
												<Input
													type="number"
													style={{ width: '100%' }}
													value={spatialWindowValue}
													onChange={(e) => {
														spatialWindowRef.current = e.target.value;
														setSpatialWindowValue(e.target.value);
													}}
												/>
											</div>
										</Col>
									) :filterTypeRef.current === 'temporalaverage' ? (
										<Col span={6}>
											<Typography.Text>Temporal Window (frames)</Typography.Text>
											<div style={{ marginTop: '8px' }}>
												<Input
													type="number"
													style={{ width: '100%' }}
													value={temporalWindowValue}
													onChange={(e) => {
														temporalWindowRef.current = e.target.value;
														setTemporalWindowValue(e.target.value);
													}}
												/>
											</div>
										</Col>
									): filterTypeRef.current === 'spectrogram' ? (
										<Col span={6}>
											<Typography.Text>FFT Window (samples)</Typography.Text>
											<div style={{ marginTop: '8px' }}>
												<Tooltip placement="bottom" title="Number of time samples used per FFT (spectrogram resolution)">
													<Input
														type="number"
														style={{ width: '100%' }}
														value={spectrogramWindowValue}
														onChange={(e) => {
															spectrogramWindowRef.current = e.target.value;
															setSpectrogramWindowValue(e.target.value);
															spectrogramHistoryRef.current = [];
														}}
													/>
												</Tooltip>
											</div>
										</Col>
									) :
										(
											<div
												style={{
													width: '100%',
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center'
												}}
											>
												<Empty
													image={Empty.PRESENTED_IMAGE_SIMPLE}
												/>
											</div>
										)}
						</Row>
					</>: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
				
				</Modal>

				<Drawer
					title={langdata && langdata.DataTransformation ? langdata.DataTransformation:'Data Transformation'}
					placement='right'
					closable={false}
					onClose={onClose}
					open={opendrawer}
					key='right'
				>	
					<>
						<Tabs defaultActiveKey="1" 
							style={{marginTop:'-15px'}}
						>
							<TabPane tab={langdata && langdata.Events ? langdata.Events:'Events'} key="1">
								<Row gutter={24}>
									{waterfall && waterfall.waterfallEvents && waterfall.waterfallEvents.map((item)=>(
										<>
											<Col key = {item.id} span={14}>
												<Typography style={{ marginTop : '15px'}}>
													{item.eventType}&nbsp;&nbsp;&nbsp;
												</Typography>
											</Col>
											<Col span={10}>
										
												<Tooltip placement="bottom" title={langdata && langdata.Pleaseentertheeventconfidencecap ? langdata.Pleaseentertheeventconfidencecap:'Please enter the event confidence cap'}>
													<Input 
														type='number'
														step="0.1"
														max='1'
														min='.1'  
														style={{width : '90%', height  :'25px', marginTop : '15px'}}
														defaultValue={item.waterfallEventConfidenceCap} 
														placeholder={langdata && langdata.EventConfidenceCap ? langdata.EventConfidenceCap: 'Event Confidence Cap'} 
														onChange={(e)=> {handleConfidenceChange(item,e);}}
													/>
												</Tooltip>
											</Col>
										</>

									))}
									<Col span={24} style={{ marginTop : '20px', display:'flex', justifyContent: 'center'}}>
										<Row gutter={24} style={{display:'flex', justifyContent: 'center'}}>
											<Col span={12} style={{ display:'flex', justifyContent: 'center'}}>
												<Button onClick={onClose}>{langdata && langdata.Close ? langdata.Close:'Close'}</Button>
											</Col>
											<Col span={12} style={{ display:'flex', justifyContent: 'center'}}>
												<Button type='primary' onClick={handleApplyConfidence}>{langdata && langdata.Apply ? langdata.Apply:'Apply'}</Button>
											</Col>
										</Row>
									</Col>
								</Row>
							</TabPane>

							<TabPane tab={langdata && langdata.DataManager ? langdata.DataManager:'Data Manager'} key="2">
								<Row gutter={24}>
									<>
										<Form>
											<Col span={24}>
												<Row gutter={24}>
													<Col span={9}>
														<Form.Item 
															label={
																<span style={{ display: 'block', textAlign: 'center', width: '100%' }}>
																	{langdata && langdata.LoggingStatus ? langdata.LoggingStatus : 'Logging Status'}
																</span>
															}
															rules={[{ required: true, message: langdata && langdata.Pleaseselectloggingstatus ? langdata.Pleaseselectloggingstatus : 'Please select logging status' }]} required>
													
														</Form.Item>
													</Col>
													<Col span={15}>
														<Select
															style={{ minWidth: '200px'}}
															showSearch
															placeholder={ langdata && langdata.Pleaseselectloggingstatus ? langdata.Pleaseselectloggingstatus : 'Please select logging status' }
															optionFilterProp="children"
															options={trueAndFalse}
															onChange={(value) => formik.setFieldValue('isLogging', value)}
															value={formik.values.isLogging}
														/>
													</Col>
												</Row>
											</Col>

											<Col span={24}>
												<Row gutter={24}>
													<Col span={9}>
														<Form.Item 
															label={
																<span style={{ display: 'block', textAlign: 'center', width: '100%' }}>
																	{langdata && langdata.DeviceName ? langdata.DeviceName : 'Device Name'}
																</span>
															} 
															rules={[{ required: true, message: langdata && langdata.Pleaseenterthedevicename ? langdata.Pleaseenterthedevicename : 'Please enter the device name' }]} required>
													
														</Form.Item>
													</Col>
													<Col span={15}>
														<Input 
															name="deviceName" 
															placeholder={langdata && langdata.Pleaseenterthedevicename ? langdata.Pleaseenterthedevicename : 'Please enter the device name'}
															onChange={formik.handleChange} 
															value={formik.values.deviceName}
														/>
													</Col>
												</Row>
											</Col>

											<Col span={24}>
												<Row gutter={24}>
													<Col span={9}>
														<Form.Item 
															label={
																<span style={{ display: 'block', textAlign: 'center', width: '100%' }}>
																	{langdata && langdata.Directory ? langdata.Directory : 'Directory'}
																</span>
															} 
															rules={[{ required: true, message: langdata && langdata.Pleaseenterthedirectory ? langdata.Pleaseenterthedirectory : 'Please enter the directory' }]} required>
														</Form.Item>
													</Col>
													<Col span={15}>
														<Tooltip placement="bottom" title={formik.values.directory}>

															<Input 
																name="directory" 
																placeholder={langdata && langdata.Pleaseenterthedirectory ? langdata.Pleaseenterthedirectory : 'Please enter the directory'}
																onChange={formik.handleChange} 
																value={formik.values.directory}
															/>
														</Tooltip>
													</Col>
												</Row>
											</Col>

											<Col span={24}>
												<Row gutter={24}>
													<Col span={9}>
														<Form.Item 
															label={langdata && langdata.FileName ? langdata.FileName : 'File Name'} 
															rules={[{ required: true, message: langdata && langdata.Pleaseenterfilename ? langdata.Pleaseenterfilename : 'Please enter file name' }]} required>
														</Form.Item>
													</Col>
													<Col span={15}>
														<Tooltip placement="bottom" title={formik.values.fileName}>
															<Input 
																name="fileName" 
																placeholder={langdata && langdata.Pleaseenterfilename ? langdata.Pleaseenterfilename : 'Please enter the file name'}
																onChange={formik.handleChange} 
																value={formik.values.fileName}
															/>
														</Tooltip>
													</Col>
												</Row>
											</Col>
											<Divider/>

											<Row gutter={24} style={{marginBottom:'10px'}}>
												<Col span={12}>
													<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.Suppressions ? langdata.Suppressions:'Suppressions'}</b></Typography>
												</Col>
												<Col span={12} justifyContent="end" style={{display:'flex', justifyContent:'flex-end'}}>
													<Button
														style={{margin:'5px'}} 
														type="primary" 
														icon={<PlusOutlined />}
														size='small'
														onClick={handleUpdateAddSuppression}
													/>
												</Col>
											</Row>

											{suppressionUpdateValues.map((input, index) => (					
						
												<Row gutter={24} key={index}>
													<Col span={11}>
														<Form.Item
															label={
																<span style={{ display: 'block', textAlign: 'center', width: '100%' }}>
																	{langdata?.Start || 'Start'}
																</span>
															}
															rules={[{ required: true, message: langdata && langdata.Pleaseselectavalidstartingchainage ? langdata.Pleaseselectavalidstartingchainage : 'Please select a valid starting chainage' }]} required
									
														>
															<Select
																style={{ minWidth: '100px'}}
																showSearch
																filterOption={filterOption}
																placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
																optionFilterProp="children"
																options={pipelineChainage}
																allowClear
																value={input.Start || input.Start == 0 && input.Start !== '' ? input.Start : null}
																onChange={e => handleUpdateChangeSuppression(index, 'Start', e)}
															/>
														</Form.Item>
													</Col>
													<Col span={10}>
														<Form.Item
															label={
																<span style={{ display: 'block', textAlign: 'center', width: '100%' }}>
																	{langdata?.End || 'End'}
																</span>
															}
															rules={[{ required: true, message: langdata && langdata.Pleaseselectavalidendingchainage ? langdata.Pleaseselectavalidendingchainage : 'Please select a valid ending chainage' }]} required
									
														>
															<Select
																style={{ minWidth: '100px'}}
																showSearch
																filterOption={filterOption}
																placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
																optionFilterProp="children"
																options={pipelineChainage}
																allowClear
																value={input.End || input.End == 0  && input.Start !== '' ? input.End : null}
																onChange={e => handleUpdateChangeSuppression(index, 'End', e)}
															/>
														</Form.Item>
													</Col>
													<Col span={3} style={{ marginTop: '3px', textAlign: 'center' }}>
														<Button
															danger
															icon={<DeleteOutlined />}
															size='small'
															onClick={() => handleUpdateDeleteSuppression(index)}
															disabled={suppressionUpdateValues.length === 0}
														/>
													</Col>
												</Row>
											))}
										</Form>
										
									</>

									<Col span={24} style={{ marginTop : '20px', display:'flex', justifyContent: 'center'}}>
										<Row gutter={24} style={{display:'flex', justifyContent: 'center'}}>
											<Col span={12} style={{ display:'flex', justifyContent: 'center'}}>
												<Button onClick={onClose}>{langdata && langdata.Close ? langdata.Close:'Close'}</Button>
											</Col>
											<Col span={12} style={{ display:'flex', justifyContent: 'center'}}>
												<Button type='primary' onClick={formik.handleSubmit}>{langdata && langdata.Apply ? langdata.Apply:'Apply'}</Button>
											</Col>
										</Row>
									</Col>
								</Row>
							</TabPane>
						</Tabs>
					
					</>
				
				</Drawer>

			</Content>

			<Spin fullscreen spinning={spin} tip={`${langdata && langdata.Loading ? langdata.Loading: 'Loading'}...`}/>
			
		</>
	);
}